<div id="el2">
  <span class="mat-headline-6 title">{{ title }}</span>
  <button mat-icon-button disableRipple (click)="dismiss()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<p class="mat-subtitle-1 message">{{ message }}</p>
